<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/ops/dashboard">Ops</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page"
        >Applications</span
      >
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">Applications</h1>
        <p class="page-head__subtitle">Every submitted application, newest first.</p>
      </div>
    </div>
  </header>

  <div class="aq-tabs" role="tablist" aria-label="Product">
    @for (t of tabs; track t.value) {
      <button
        class="aq-tab"
        type="button"
        role="tab"
        [id]="'aq-tab-' + t.value"
        aria-controls="aq-panel"
        [attr.aria-selected]="product() === t.value"
        [class.aq-tab--active]="product() === t.value"
        (click)="select(t.value)"
      >
        {{ t.label }}
      </button>
    }
  </div>

  <div
    id="aq-panel"
    class="aq-panel"
    role="tabpanel"
    [attr.aria-labelledby]="'aq-tab-' + product()"
  >
    @if (product() === 'df') {
      <app-df-facility-queue [embedded]="true" />
    } @else {
      <app-ks-queue />
    }
  </div>
</div>
